<template>
  <section class="py-2 text-sm flex flex-wrap items-start gap-3 hover:bg-slate-100 bg-slate-50 rounded-lg p-2">
    <transition
      name="fade"
      mode="out-in"
    >
      <UButton
        v-if="!read"
        icon="heroicons:envelope"
        @click="toggleReadValue()"
      />
      <UButton
        v-else
        variant="ghost"
        icon="heroicons:envelope-open"
        @click="toggleReadValue()"
      />
    </transition>

    <Paragraph
      :data="note.message"
      class="flex-1 text-left line-clamp-2"
      @click.stop="$emit('view')"
    />
  </section>
</template>

<script setup lang="ts">
  import type { MNotification } from '~/types/index'
const note = defineProps<MNotification>()
const read = ref(false)
onMounted(() => {
  read.value = note.read
})
const { toggleRead } = useNotification()

function toggleReadValue() {
  toggleRead({ ...note, read: read.value })
  read.value = !read.value
}
</script>

<style scoped>

</style>
